import { render } from "./FormControl.vue?vue&type=template&id=b82f3450&scoped=true"
import script from "./FormControl.vue?vue&type=script&lang=js"
export * from "./FormControl.vue?vue&type=script&lang=js"

import "./FormControl.vue?vue&type=style&index=0&id=b82f3450&scoped=true&lang=css"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82f3450"]])

export default __exports__